// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var TCSSiteType;
(function (TCSSiteType) {
    TCSSiteType[TCSSiteType["None"] = -1] = "None";
    TCSSiteType[TCSSiteType["Facility"] = 0] = "Facility";
    TCSSiteType[TCSSiteType["Infusion"] = 1] = "Infusion";
    TCSSiteType[TCSSiteType["Pharmacy"] = 2] = "Pharmacy";
})(TCSSiteType || (TCSSiteType = {}));
//# sourceMappingURL=tCSSiteType.js.map